import { IStatusIntegracaoUAU } from "../../../Interfaces/Geral/Dashboard/DashboardInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetStatusIntegracaoUauService() {
    return Service(
        Axios.get<IStatusIntegracaoUAU>(
            `/home/integracoes/getstatusintegracaouau`
        )
    );
}
